'use strict';

exports.__esModule = true;

var _animate = require('./dom/animate');

var _animate2 = _interopRequireDefault(_animate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { animate: _animate2.default };
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-widgets/lib/util/configuration.js
 ** module id = 253
 ** module chunks = 0
 **/